import ConfirmationAlert, {AlertProps} from "../components/Common/AlertComponent";

type AlertDefaults = {
  [type in AlertTypes]: AlertProps;
};

export enum AlertTypes {
  OAUTH_LOGIN_FAILED = "OAUTH_LOGIN_FAILED",
}

const DefaultAlertValues: AlertDefaults = {
  [AlertTypes.OAUTH_LOGIN_FAILED]: {
    title: "Login failed",
    message: "An error occurred or the process was cancelled by the user",
    confirmLabel: "Close",
    onConfirm: () => defaultOnConfirm(),
  }
}

const defaultOnConfirm = () => {
  removeAlertSearchParam()
}

/**
 * Gets search params, removes ALERT_MESSAGE_SEARCH_PARAM and replaces window.history
 */
const removeAlertSearchParam = () => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(ALERT_MESSAGE_SEARCH_PARAM);
  const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  window.history.replaceState({}, document.title, newUrl);
}

const ALERT_MESSAGE_SEARCH_PARAM = "alert-message";

class AlertService {
  constructor() {}

  showDefaultAlert(alertType: AlertTypes) {
    if (Object.keys(DefaultAlertValues).includes(alertType)) {
      ConfirmationAlert(DefaultAlertValues[alertType])
    }
  }

  getAlertSearchParam(): string {
    return ALERT_MESSAGE_SEARCH_PARAM;
  }
}

export default new AlertService();
